const extractNumbers = text => (text ? text.replace(/\D+/g, '') || '0' : '0');
const truncate = text => text.substring(0, 9);
const parseToInt = text => parseInt(text, 10);

// This function extracts the senderId, which consists in max 9 numbers.
// Currently, the input is the connection ID.
// For example, "5a12917d-395b-483a-bbd7-a91dfa4c2a53" -> "512917395".
module.exports = text => parseToInt(truncate(extractNumbers(text)));
